import { render, staticRenderFns } from "./card-sale-model.vue?vue&type=template&id=6ebc5404&lang=pug&"
import script from "./card-sale-model.vue?vue&type=script&lang=js&"
export * from "./card-sale-model.vue?vue&type=script&lang=js&"
import style0 from "./card-sale-model.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports